const fetch = require('node-fetch');

class PublicConfig {
  async loadURLs(env) {
    const [internal, external] = await Promise.all([
      this.#loadJson(`internal/${env}.json`),
      this.#loadJson(`external/${env}.json`)
    ]);

    const data = Object.assign({}, internal?.url, external?.url);
    data.api = Object.assign({}, internal?.url?.api, external?.url?.api);

    return data;
  }

  async #loadJson(filepath) {
    const response = await fetch(`https://transfeeradata.s3.amazonaws.com/urls-config/${filepath}`);
    return response.json();
  }
}

module.exports = PublicConfig;
